module.exports = __webpack_public_path__ + "static/media/poppins-300.42d3308e.woff2";